import { motion, Variants } from "framer-motion";
import React from "react";
import DropdownItem, { DropdownItemProps } from "./DropdownItem";

interface DropdownMenuProps {
  containerStyle: string;
  optionsList: DropdownItemProps[];
  variants?: Variants;
}

/**
 * Definition of the variants of this component
 */
const defaultVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: {
    opacity: 0,
    transition: { duration: 0.1, ease: "easeOut" },
  },
};

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  containerStyle,
  optionsList,
  variants = defaultVariants,
}) => {
  return (
    <motion.div
      className={containerStyle}
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1, ease: "easeOut" }}
    >
      {optionsList &&
        optionsList.map((item: DropdownItemProps, index: number) => {
          return (
            <DropdownItem
              key={index}
              icon={item.icon}
              text={item.text}
              onClickFunction={item.onClickFunction}
            />
          );
        })}
    </motion.div>
  );
};

export default DropdownMenu;
